module.exports = __webpack_public_path__ + "img/PM_A02_back_diagonal_horizontal_en.70c144dc.png";